import axios from "@/utils/service/http";
import dayjs from "dayjs";
import { isPlainObject } from "lodash";

const CACHE_TIME = process.env.VUE_APP_PROJECT_CACHE_TIME ?? 20;

const state = {
    projects: [],
    projectsUpdatedAt: null,
};

const getters = {
    getProject: (state) => (projectId) => {
        return state.projects.find(({ url }) => url === projectId);
    },
};

const mutations = {
    SET_PROJECT: (state, project) => {
        state.projects = [
            ...state.projects.filter(({ url }) => url !== project.url),
            { ...project, downloadTime: dayjs().toISOString() },
        ];
    },
    SET_PROJECTS: (state, projects) => {
        state.projects = projects || [];
    },
    SET_PROJECTS_UPDATE: (state, date = null) => {
        state.projectsUpdatedAt = date || dayjs().toISOString();
    },
    ADD_PROJECT: (state, project) => {
        state.projects.push(project);
    },
    UPDATE_PROJECT_DOCUMENTS(state, { projectUrl, document }) {
        const project = state.projects.find(({ url }) => url === projectUrl);

        if (!project) return console.warn("Project not found");

        if (!project.documents) Object.assign(project, { documents: [] });

        project.documents = project.documents.filter(
            ({ type }) => type !== document.type
        );

        project.documents.push(document);
    },
    UPDATE_PROJECT_INFORMATION(state, { projectUrl, information }) {
        const project = state.projects.find(({ url }) => url === projectUrl);

        if (!project) return console.warn("Project not found");

        Object.assign(project, { information });
    },

    UPDATE_PROJECT_COOKIE_CONSENT(state, { projectUrl, cookieConsent }) {
        const project = state.projects.find(({ url }) => url === projectUrl);

        if (!project) return console.warn("Project not found");

        project.cookie_consent = cookieConsent;
    },
};

const actions = {
    getProjects: async ({ state, commit }, force = false) => {
        if (
            !force &&
            state.projects.length > 0 &&
            state.projectsUpdatedAt &&
            dayjs().diff(dayjs(state.projectsUpdatedAt), "second") < CACHE_TIME
        )
            return state.projects;

        const data = await axios.get("/api/v1/projects");
        commit("SET_PROJECTS", data);
        commit("SET_PROJECTS_UPDATE");
        return data;
    },
    getProject: async ({ state, commit }, project_id) => {
        if(!project_id) return null;

        let force = false

        if(isPlainObject(project_id)) {
            force = project_id.force || force;
            project_id = project_id.project_id;
        }

        const existingProject = state.projects.find(
            ({ url }) => url === project_id
        );

        if (
            !force &&
            existingProject &&
            existingProject.downloadTime &&
            dayjs().diff(dayjs(existingProject.downloadTime), "second") < CACHE_TIME
        ) {
            return existingProject;
        } else {
            const project = await axios.get(`/api/v1/projects/${project_id}`);
            commit("SET_PROJECT", project);
            return project;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
